export default __webpack_public_path__ + "static/media/desire.fc0c1203.mp3";